import { SET_GIFT_CARD } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const setGiftCard = (code, balance, barberName, barberId) => ({
  type: SET_GIFT_CARD,
  payload: { code, balance, barberName, barberId },
});
